/** returns all payments operators list
@return { Array }
*/
export const getPaymentsOperatorsList = state => state.paymentsOperatorsList

export const getPaymentOperatorName = state => operatorId => {
    if (!state.parsedPaymentsOperatorsListNames.length ||
        !state.parsedPaymentsOperatorsListNames.find(payment => payment.id === parseInt(operatorId))) return operatorId

    return state.parsedPaymentsOperatorsListNames.find(payment => payment.id === parseInt(operatorId)).description
}

/** returns payments list
@return { Array }
*/
export const getPaymentsList = state => state.paymentsList

/** returns favorites list
@return { Array }
*/
export const getFavoritesList = state => state.favoritesList

/** returns favorites tabs
@return { Array }
*/
export const getFavoritesTabs = state => state.favoritesTabs

/** returns Favorites hasMore value
@return { Boolean }
*/
export const getFavoritesHasMore = state => state.favoritesHasMore

/** returns Accounts Balances
@return { Array }
*/
export const getPaymentDetail = state => state.paymentDetail

/** returns frequent operations
@return { String }
*/
export const getFrequentOperations = state => state.frequentOperations
